import { render, staticRenderFns } from "./ActiveChecksAddConfigPage.vue?vue&type=template&id=56296c42"
import script from "./ActiveChecksAddConfigPage.vue?vue&type=script&lang=js"
export * from "./ActiveChecksAddConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports